import { createContext, useContext } from "react";
import { FormProvider as RHFFormProvider, useFormContext } from "react-hook-form";

/**
 * FormProvider
 * ------------
 * Use instead of react-hook-form's FormProvider: `<FormProvider {...form}>`.
 * react-hook-form's provider only passes its own methods down, so this also
 * shares the full useAppForm object (with setRules / isPathValid) via
 * `useAppFormContext()`.
 */
const AppFormContext = createContext(null);

export const FormProvider = ({ children, ...form }) => (
  <AppFormContext.Provider value={form}>
    <RHFFormProvider {...form}>{children}</RHFFormProvider>
  </AppFormContext.Provider>
);

/** The useAppForm object of the closest FormProvider (null outside one). */
export const useAppFormContext = () => {
  const appForm = useContext(AppFormContext);
  const rhf = useFormContext();
  return appForm ?? rhf;
};
